import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const MessagesList = ({
  messages,
  phoneNumberFontSize,
  authorFontSize,
  msgFontSize,
  currentState,
  winId,
  speed,
  user,
}) => {
  return (
    <div className={styles['wrapper']}>
      {currentState &&
        (currentState === 'S6' ||
          currentState === 'S7' ||
          (currentState === 'S8' && messages.length > 3)) && (
          <div className={styles['messagesWrapper']}>
            <TransitionGroup className={styles['messages']} appear={true}>
              {messages.length > 0 &&
                messages.map((item, i) => (
                  <CSSTransition
                    key={item.UUID}
                    timeout={speed}
                    classNames="position"
                  >
                    <Message
                      winId={winId}
                      key={item.id}
                      message={item.message}
                      titrTag={item.titrTag}
                      authorFontSize={authorFontSize}
                      msgFontSize={msgFontSize}
                      phoneNumberFontSize={phoneNumberFontSize}
                      currentState={currentState}
                      user={user}
                    />
                  </CSSTransition>
                ))}
            </TransitionGroup>
          </div>
        )}
    </div>
  );
};

export default MessagesList;
